import { tts } from "./api";
import type { TtsRequestOptions } from "./api";

/** Stable key for deduping identical TTS requests. */
function cacheKey(text: string, opts: TtsRequestOptions): string {
  return JSON.stringify({
    t: text,
    v: opts.voice ?? "fable",
    a: opts.accent ?? "british",
    s: opts.style ?? "tutor",
    aud: opts.audience,
    y: opts.year_group,
    i: opts.instructions,
  });
}

/** In-flight + resolved base64 audio — one promise per unique script + voice options. */
const ttsInflight = new Map<string, Promise<string>>();

/**
 * Fetch server TTS audio (base64 MP3), with request deduplication.
 * Multiple callers await the same promise while one request is in flight.
 */
export function getCachedTtsBase64(text: string, opts: TtsRequestOptions): Promise<string> {
  const key = cacheKey(text, opts);
  let p = ttsInflight.get(key);
  if (!p) {
    p = tts(text, opts).catch((e) => {
      ttsInflight.delete(key);
      throw e;
    });
    ttsInflight.set(key, p);
  }
  return p;
}

/** Warm the cache in the background (no throw — failures are ignored). */
export function prefetchTtsBase64(text: string, opts: TtsRequestOptions): void {
  const trimmed = text.trim();
  if (!trimmed) return;
  getCachedTtsBase64(trimmed, opts).catch(() => {});
}
